import { GameObject } from './game-object';
import { EventEmitter } from 'events';

export class Monkey extends GameObject {
    constructor() {
        super();
    }
}
